<div class="game g_{{gameId}} fullscreen_{{fscr}} runAnim_{{runAnim}}" [style.backgroundImage]="'url(' + gameBackground + ')'">
  <div class="g {{mode}}" [style.width.px]="frameWidth">
    <div class="preIframe {{mode}}" id="preIframeWrapper" [style.width.px]="frameWidth" [style.height.px]="frameHeight" [ngClass]="{'errorOnGame' : error069 || error1042}">
      <div class="casinoRoyaleLoader">
        <div class="loaderBall"></div>
        <div class="loaderShadow"></div>
      </div>
      <iframe *ngIf="showIframe && allowFullScreen" id="game-iframe" allow="autoplay" allowfullscreen src="about:blank" width="{{frameWidth}}" height="{{frameHeight}}" #iframe [src]="gameURL | safe" class="{{showIframe}}"></iframe>
      <iframe *ngIf="showIframe&& !allowFullScreen" id="game-iframe" allow="autoplay" src="about:blank" width="{{frameWidth}}" height="{{frameHeight}}" #iframe [src]="gameURL | safe" class="{{showIframe}}"></iframe>
      <div *ngIf="error069 || error1042 || error10422" class="errorOnScratch">
        <img src="../../../assets/images/payments/icon-add-funds.svg" alt="404">
        <h4 *ngIf="error000">{{'scratchcards.error000' | translate}}</h4>
        <h4 *ngIf="error102">{{'scratchcards.error102' | translate}}</h4>
        <h4 *ngIf="error069">{{'errors.069' | translate }}</h4>
        <h4 class="strong" *ngIf="error1042">{{ 'insta.nav1' | translate }}</h4>
        <h4 class="strong" *ngIf="error10422">{{ 'insta.nav1' | translate }}</h4>
        <h4 class="span" *ngIf="error1042">{{ 'insta.nav2' | translate }}</h4>
        <h4 class="span" *ngIf="error10422">{{ 'insta.nav2' | translate }}</h4>
        <div class="text-center" *ngIf="!error069">
          <div (click)="closeGame(gameId, true);" *ngIf="mode === 'instagames'" class="btn">{{ 'insta.nav3' | translate }}</div>
          <div (click)="addFunds(gameId);" *ngIf="!lotteryService.isMobile && mode !== 'instagames'" class="btn">{{ 'insta.nav3' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="addFunds {{mode}} {{language}}" (click)="addFundsOrPM(gameId);" *ngIf="!lotteryService.isMobile">
      <div class="text">{{ 'nav.mad' | translate }}</div>
      <div class="plus"></div>
    </div>
    <div class="fullScreen {{mode}}" (click)="fullScreen();" *ngIf="!lotteryService.isMobile"></div>
    <div class="close {{mode}}" (click)="closeGame(gameId, true);" *ngIf="!lotteryService.isMobile"></div>
  </div>
</div>
